import _ from "lodash"

/**
 * save the document at firebase
 *
 * @param {object} data     - document fields
 * @param {string} docPath  - doc path in the firestore
 * @param {string} imgPath  - img path in the firestorage
 */
export let addDoc = async (data, docPath, imgPath = null) => {
   let db = window.firebaseFirestore
   let ref = db.collection(docPath)

   let {
      image
   } = data
   delete data.image

   // save the doc
   let docRef = await ref.add(data)
   let {
      id
   } = docRef

   // upload the image
   if (imgPath && image) {
      let url = await getImageUrl(image, `${imgPath}/${id}`)

      return await ref.doc(id).set({
         image: url
      }, {
         merge: true
      })
   }

   return docRef
}

/**
 * update a document at firebase
 *
 * @param {object} data     - document fields
 * @param {string} docPath  - doc path in the firestore
 * @param {string} imgPath  - img path in the firestorage
 */
export let updateDoc = async (data, docPath, imgPath = null) => {
   let db = window.firebaseFirestore
   let ref = db.doc(docPath)

   let {
      image
   } = data
   delete data.image
   delete data.index

   if (image) {
      // upload the new image
      let url = await getImageUrl(image, imgPath)

      // update the doc
      return await ref.set({
         ...data,
         image: url
      }, {
         merge: true
      })
   } else {
      return await ref.set(data, {
         merge: true
      })
   }
}

/**
 * delete a document at firebase
 *
 * @param {object} data
 * @param {string} docPath - doc path in the firestore
 * @param {string} imgPath - img path in the firestorage
 */
export let deleteDoc = async (docPath) => {
   let db = window.firebaseFirestore
   let ref = db.doc(docPath)

   // delete the doc
   await ref.delete()
}

// -------------- dealing with image -----------------
/**
 * delete image from firebase storage
 *
 * @param {string} path
 */
export let deleteImage = (path) => {
   try {
      let storageRef = window.firebaseStorage.ref()
      let imgRef = storageRef.child(path)

      imgRef.delete()
   } catch (error) {
      console.error(error)
   }
}

/**
 * upload the image to firebase storage and get the url
 *
 * NOTE: the image name will be same of the category id
 *      (To facilitate the edit and delete process)
 *
 * @param {File} image
 * @param {string} imgPath
 * @returns {string} url
 */
export let getImageUrl = async (image, imgPath) => {
   let storageRef = window.firebaseStorage.ref()
   let upload = storageRef.child(imgPath)

   let snapshot = await upload.put(image)

   let url = await snapshot.ref.getDownloadURL()

   return url
}

/**
 * delete all images at the folder
 *
 * @param {string} path - pthe of the imgs folder
 */
export let deleteFolderContents = (path) => {
   let ref = window.firebaseStorage.ref(path)

   ref
      .listAll()
      .then((dir) => {
         dir.items.forEach((fileRef) =>
            deleteImage(ref.fullPath + "/" + fileRef.name)
         )
         dir.prefixes.forEach((folderRef) =>
            deleteFolderContents(folderRef.fullPath)
         )
      })
      .catch((error) => {
         console.log(error)
      })
}